__turbopack_context__.v({
  "field": "coupon-field-module-scss-module__H5Niyq__field",
  "placeholder": "coupon-field-module-scss-module__H5Niyq__placeholder",
});
